import { render, staticRenderFns } from "./RedirectLogin.vue?vue&type=template&id=6461a6ca&"
import script from "./RedirectLogin.vue?vue&type=script&lang=js&"
export * from "./RedirectLogin.vue?vue&type=script&lang=js&"
import style0 from "./RedirectLogin.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports